import React from "react";

function Left(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="12"
      fill="currentColor"
      viewBox="0 0 9 12"
      {...props} 
    >
      <path d="M2 5.56l-.614-.79-1.015.79 1.015.79L2 5.56zM7.386.104l-6 4.667 1.228 1.578 6-4.666L7.386.104zm-6 6.245l6 4.667 1.228-1.579-6-4.666-1.228 1.578z"></path>
    </svg>
  );
}

export default Left;